/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DataSharingGrantsItemRequestBuilderNavigationMetadata, type DataSharingGrantsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/data-sharing-grants
 */
export interface DataSharingGrantsRequestBuilder extends BaseRequestBuilder<DataSharingGrantsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.customers.dataSharingGrants.item collection
     * @param id Unique identifier of the item
     * @returns {DataSharingGrantsItemRequestBuilder}
     */
     byId(id: Guid) : DataSharingGrantsItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DataSharingGrantsRequestBuilderUriTemplate = "{+baseurl}/customers/data-sharing-grants";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DataSharingGrantsRequestBuilderNavigationMetadata: Record<Exclude<keyof DataSharingGrantsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        navigationMetadata: DataSharingGrantsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
};
/* tslint:enable */
/* eslint-enable */
